import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Row, Col } from "react-bootstrap";
import ContactDetailField from "../../../molecules/ContactDetailField";
import Input from "../../../atoms/Input";
import DynamicText from "../../../molecules/DynamicText";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const AcknowledgementReceiptDownload = ({ formContent, surveyData }) => {
  const { surveyId, id, flg } = useParams();
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <div className="premium-print-container mx-4">
      <div className="section-divider mb-3">
        <h1 className="section-title">Acknowledgement Receipt</h1>
      </div>

      {/* receipt detail*/}
      <div className="data-grid mb-4">
        <div className="data-item">
          <span className="data-label">Date</span>
          <span className="data-value">{formContent?.date ? formatDate(formContent?.date) : "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Received From</span>
          <span className="data-value">{formContent?.receivedFrom || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Address</span>
          <span className="data-value">{formContent?.address || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">On Account of</span>
          <span className="data-value">{formContent?.onAccountOf || "-"}</span>
        </div>
      </div>

      {/* Financial Details */}
      <div className="section-divider mb-2">
        <h2 className="section-title" style={{ fontSize: '11pt' }}>Payment Details</h2>
      </div>
      <div className="data-grid mb-5">
        <div className="data-item">
          <span className="data-label">Amount</span>
          <span className="data-value" style={{ fontSize: '14pt', color: '#0f172a', fontWeight: 800 }}>
            {formContent?.amount || "-"}
          </span>
        </div>
        <div className="data-item">
          <span className="data-label">Cash/Cheque #</span>
          <span className="data-value">{formContent?.chequeNo || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Drawn on Bank</span>
          <span className="data-value">{formContent?.drawnOnBank || "-"}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Received By</span>
          <span className="data-value">{formContent?.receivedBy || "-"}</span>
        </div>
      </div>

      {formContent?.inWords && (
        <div className="mb-5 p-3" style={{ background: '#f8fafc', borderRadius: '4px', border: '1px solid #e2e8f0' }}>
          <span className="data-label">Amount in Words</span>
          <p className="mb-0 mt-1" style={{ fontSize: '11pt', fontStyle: 'italic', color: '#334155' }}>
            "{formContent.inWords}"
          </p>
        </div>
      )}

      {/* footer text */}
      <div className="mt-5 pt-5 text-center">
        <div className="d-flex justify-content-center gap-5">
          <div className="text-center" style={{ width: '200px' }}>
            <div style={{ height: '60px', borderBottom: '1px solid #cbd5e1', marginBottom: '10px' }}></div>
            <p className="fw-bold" style={{ fontSize: '10pt' }}>Receiver's Signature</p>
          </div>
          <div className="text-center" style={{ width: '200px' }}>
            <div style={{ height: '60px', borderBottom: '1px solid #cbd5e1', marginBottom: '10px' }}></div>
            <p className="fw-bold" style={{ fontSize: '10pt' }}>Authorized Signatory</p>
          </div>
        </div>
      </div>

    </div>
  );
};
export default AcknowledgementReceiptDownload;
